export const enum Env {
  Development = 'development',
  Preview = 'preview',
  Production = 'production'
}
